"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCatalogEntityCase = createCatalogEntityCase;
// Routes actions to individual catalog entities by catalogId
function createCatalogEntityCase(reducer) {
    return (state, action) => {
        const catalogId = action.payload.id;
        const entity = state[catalogId];
        if (entity) {
            state[catalogId] = reducer(entity, action);
        }
    };
}
